import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const AdminLogin = () => {
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#08070D] flex items-center justify-center px-6">
      <div className="grain" />
      <motion.div
        data-testid="admin-login-modal"
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md bg-[#151421] border border-white/[0.08] rounded-2xl p-10"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-[#10B981]/10 border border-[#10B981]/20 flex items-center justify-center">
            <Lock size={18} className="text-[#10B981]" />
          </div>
          <h1 className="font-display font-bold text-2xl text-white">Yönetici Girişi</h1>
        </div>
        <p className="text-sm text-[#6B7280] mb-8">Başvuruları görüntülemek için giriş yap.</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="admin-email" className="text-sm text-[#9CA3AF]">E-posta</Label>
            <Input
              id="admin-email" type="email" required data-testid="admin-input-email"
              placeholder="admin@befora.dev" value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-[#0F0E17] border-white/10 focus:border-[#10B981]/50 text-white h-12 rounded-xl"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password" className="text-sm text-[#9CA3AF]">Şifre</Label>
            <Input
              id="admin-password" type="password" required data-testid="admin-input-password"
              placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)}
              className="bg-[#0F0E17] border-white/10 focus:border-[#10B981]/50 text-white h-12 rounded-xl"
            />
          </div>

          {error && (
            <div data-testid="admin-login-error" className="text-sm text-red-400 bg-red-400/10 border border-red-400/20 rounded-xl px-4 py-3">
              {error}
            </div>
          )}

          <button
            type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full flex items-center justify-center gap-2 bg-[#10B981] hover:bg-[#0ea371] disabled:opacity-60 text-[#08070D] font-semibold py-3.5 rounded-full transition-colors duration-300"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Giriş Yap"}
          </button>
        </form>

        <Link
          to="/" data-testid="admin-back-to-site-link"
          className="flex items-center justify-center gap-1.5 text-sm text-[#6B7280] hover:text-white transition-colors duration-300 mt-8"
        >
          <ArrowLeft size={14} />
          Siteye dön
        </Link>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
